/**
 * 1 Nov 2026 (D-1102-CREW): the crew's phone — two Admin → Settings switches, read by the app from the Day plan
 * settings every role already gets (/api/dayplan carries every HK_ row).
 *
 *   HK_TODAY_LIVE_REFRESH  Yes (default)  Today, and the day plan under it, read again every minute while the screen is
 *                                         open and showing, and mark a card whose time or order changed.
 *   HK_CREW_OFFLINE        No  (default)  "Crew can save while offline": Arrived, Finish and their photos are kept on the
 *                                         phone when there is no signal and sent, in order, when it returns.
 */
export const LIVE_REFRESH_KEY = 'HK_TODAY_LIVE_REFRESH';
export const CREW_OFFLINE_KEY = 'HK_CREW_OFFLINE';

type Settings = Record<string, string | undefined> | undefined | null;
const yes = (v: string | undefined): boolean => /^(yes|true|on|1)$/i.test(String(v ?? '').trim());
const no = (v: string | undefined): boolean => /^(no|false|off|0)$/i.test(String(v ?? '').trim());

/** On unless the row says No (a site with no row is on). */
export function liveRefreshOn(settings: Settings): boolean {
  return !no(settings?.[LIVE_REFRESH_KEY]);
}

/** Off unless the row says Yes (a site with no row is off — today's behaviour). */
export function crewOfflineOn(settings: Settings): boolean {
  return yes(settings?.[CREW_OFFLINE_KEY]);
}

/** How often Today reads again while it is showing (ms). */
export const LIVE_REFRESH_MS = 60_000;
